import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountRoutingModule } from './account-routing.module';
import { ProfileComponent } from './profile/profile.component';
import { CashierComponent } from './cashier/cashier.component';
import { JackpotsComponent } from './jackpots/jackpots.component';
import {TranslateModule} from "@ngx-translate/core";
import { UserPromotionsComponent } from './user-promotions/user-promotions.component';
import {ReactiveFormsModule} from "@angular/forms";


@NgModule({
  declarations: [
    ProfileComponent,
    CashierComponent,
    JackpotsComponent,
    UserPromotionsComponent
  ],
    imports: [
        CommonModule,
        AccountRoutingModule,
        TranslateModule.forChild(),
        ReactiveFormsModule
    ]
})
export class AccountModule { }
